import { Box } from '@mui/material';
import useBranchDetails from 'api/branch/useBranchDetail/useBranchDetail';
import BranchCodingList from 'components/private/Branches/BranchCodingList';
import BranchDetailsInfo from 'components/private/Branches/BranchDetailsInfo';
import BranchPackagingList from 'components/private/Branches/BranchPackagingList';
import SpinnerLoader from 'components/shared/SpinnerLoader/SpinnerLoader';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const BranchDetails = () => {
  const { branchGuid } = useParams();
  const { getBranchDetails, branchDetails, loading } = useBranchDetails();

  const fetchBranchDetails = () => {
    getBranchDetails({ branchGuid });
  };

  useEffect(() => {
    if (branchGuid) {
      fetchBranchDetails();
    }
  }, []);

  function refreshBranchData() {
    fetchBranchDetails();
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
      {loading ? (
        <SpinnerLoader loading={loading} />
      ) : (
        <>
          <BranchDetailsInfo
            refetchBranchDetails={fetchBranchDetails}
            branchDetails={branchDetails}
          />
          <BranchCodingList
            codingList={branchDetails?.coddingList}
            refreshBranchData={refreshBranchData}
            branchGuid={branchGuid}
          />
          <BranchPackagingList
            packagingList={branchDetails?.packagingList}
            branchGuid={branchGuid}
            refreshBranchData={refreshBranchData}
          />
        </>
      )}
    </Box>
  );
};

export default BranchDetails;
